// Staff-only "professional PR" upsell — quote/confirm pending leads, then assign/track
// the MGN editorial writer responsible for each press_release_professional deliverable.
const pressReleaseAssignments = [
	{
		path: '/agency/press-release-assignments/leads',
		name: 'agency-pr-assignments-leads',
		component: () => import('@/views/agency/press-release-assignments/leads.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/press-release-assignments/board',
		name: 'agency-pr-assignments-board',
		component: () => import('@/views/agency/press-release-assignments/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
]

export default pressReleaseAssignments
